import { Middleware } from 'redux';
import createSagaMiddleware, { SagaMiddleware } from 'redux-saga';

// import ownMiddlewares from './middlewares';
import reducers from './reducers';
import sagas from './sagas';
import { configureStore } from '@reduxjs/toolkit';
import { getPreloadedState, localStorageMiddleware } from './customMiddleware';

// collecting middlewares
const sagaMiddleware: SagaMiddleware = createSagaMiddleware();
const middlewares: Middleware[] = [sagaMiddleware, localStorageMiddleware];

export const store = configureStore({
  reducer: reducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ thunk: false }).concat(middlewares),
});

sagaMiddleware.run(sagas);
